<template>
    <transition name="Controls" appear>
        <div class="Controls">
            <div class="Controls__item" :class="{ 'selected': categorie == item.id }" v-for="item in items" v-if="ready" @click="onClick(item.id)">{{ item.txt[lang] }}</div>
        </div>
    </transition>
</template>
<script>

import { Categories } from '../js/Categories.js'

export default { 
    name: 'Controls',
    data: ()=>({
        ready: false,
        items: []
    }),
    computed: {
        categorie() { return this.$store.getters['app/categorie'] },
    },
    mounted() {
        _.each(Categories, (i)=>this.items.push(i))
        this.ready = true
    },
    methods: {
        onClick(id) {
            this.$store.commit('app/SET_AMBIANCE', 'page')
            this.$store.commit('app/SET_CATEGORIE', id)
        },
    },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Controls
    position absolute
    top 50%
    left 0
    transform translate(0, -50%) 
    display flex 
    flex-direction column
    justify-content center 

    transition opacity .5s, transform .5s
    transition-delay .5s

    &-enter
        transform translate(-100%, -50%)
        opacity 0
    &-leave-active
        transition-delay 0s
        transform translate(-100%, -50%)
        opacity 0

    &__item 
        cursor pointer
        background white
        color black
        padding 8px 24px 8px 32px
        border-radius unset
        border-top-right-radius 24px
        border-bottom-right-radius 24px
        margin 4px 0
        transition opacity .5s, transform .35s
        transform translateX(-20px)

        &.selected 
            background black
            color white
            transform translateX(0px)

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Controls.vue